import { __assign } from "tslib";
import React from 'react';
import { Hidden, Visible } from '@wix/wix-ui-icons-common';
import { Box } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
export function withPasswordVisibility(WrappedComponent) {
    // Try to create a nice displayName for React Dev Tools.
    var displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    // Creating the inner component. The calculated Props type here is the where the magic happens.
    var InputWithPasswordVisibility = function (props, ref) {
        var t = useTranslation().t;
        var _a = React.useReducer(function (state) { return !state; }, false), visible = _a[0], toggleVisibility = _a[1];
        var handleEnterPressed = function (e) {
            if (e.key === 'Enter') {
                toggleVisibility();
            }
        };
        var showOrHideSuffix = (React.createElement(Box, { verticalAlign: "middle", dataHook: "password-visibility-suffix", key: "visibility-suffix" }, visible ? (React.createElement(Hidden, { tabIndex: 0, role: "button", "aria-label": t('hide.password'), style: {
                cursor: 'pointer',
            }, onClick: toggleVisibility, onKeyDown: handleEnterPressed })) : (React.createElement(Visible, { tabIndex: 0, role: "button", "aria-label": t('show.password'), style: {
                cursor: 'pointer',
            }, onClick: toggleVisibility, onKeyDown: handleEnterPressed }))));
        var suffix = [];
        if (props.showVisibility) {
            suffix.push(showOrHideSuffix);
        }
        if (props.suffix) {
            suffix.push(props.suffix);
        }
        // props comes afterwards so the can override the default ones.
        return (React.createElement(WrappedComponent, __assign({}, props, { suffix: suffix, type: visible ? 'text' : 'password', ref: ref })));
    };
    InputWithPasswordVisibility.displayName = "withPasswordVisibility(".concat(displayName, ")");
    return React.forwardRef(InputWithPasswordVisibility);
}
//# sourceMappingURL=WithPasswordVisibility.js.map